export default __webpack_public_path__ + "static/media/Common Crane.2de43cdd.jpg";